import {
  AUDIENCE_SEGMENT_PROSPECTING,
  AUDIENCE_SEGMENT_RETARGETING,
  AUDIENCE_SEGMENT_UNCLASSIFIED,
} from "@nexus/contracts";

const AUDIENCE_SEGMENT_LABELS: Record<string, { suffix: string; fallback: string }> = {
  [AUDIENCE_SEGMENT_PROSPECTING]: { suffix: "prospecting", fallback: "Prospecting" },
  [AUDIENCE_SEGMENT_RETARGETING]: { suffix: "retargeting", fallback: "Retargeting" },
  [AUDIENCE_SEGMENT_UNCLASSIFIED]: { suffix: "unclassified", fallback: "Unclassified" },
};

/** Translates a My Brand audience-segment token; unknown values pass through. */
export function audienceSegmentLabel(
  t: (key: string, defaultValue: string) => string,
  namespace: "overview" | "drilldown",
  value: string,
): string {
  const entry = AUDIENCE_SEGMENT_LABELS[value];
  if (!entry) return value;
  return t(`${namespace}.filters.${entry.suffix}`, entry.fallback);
}
